/** Соседи текущей брони в списке. `null` в поле — край списка, дальше идти некуда. */
export type Neighbours = {
  prev: string | null
  next: string | null
}

/**
 * Пара «пред/след» в шапке карточки ходит по УЖЕ ЗАГРУЖЕННЫМ строкам списка броней — своей
 * ручки «соседняя бронь» в контракте нет, и выдумывать её нельзя.
 *
 * `null` на выходе (а не пара из двух `null`) — брони в списке НЕТ. Это не то же самое, что
 * «бронь на краю списка»: карточку могли открыть с шахматки, задач или чатов, где списка нет
 * вовсе, либо перезагрузить страницу на `?booking=` с фильтром, под который бронь не подходит.
 * Звать в такой ситуации две мёртвые кнопки `disabled` значило бы пообещать соседей, которых
 * не существует, — пару в этом случае не рисуем совсем (см. вызов в `BookingModal`).
 */
export function findNeighbours(ids: readonly string[], currentId: string): Neighbours | null {
  const index = ids.indexOf(currentId)
  if (index === -1) return null

  // `noUncheckedIndexedAccess` — на краях это `undefined`, приводим к `null` явно.
  return {
    prev: ids[index - 1] ?? null,
    next: ids[index + 1] ?? null,
  }
}
